import { render, staticRenderFns } from "./Vacancies.vue?vue&type=template&id=66e4e55a&scoped=true"
import script from "./Vacancies.vue?vue&type=script&lang=js"
export * from "./Vacancies.vue?vue&type=script&lang=js"
import style0 from "./Vacancies.vue?vue&type=style&index=0&id=66e4e55a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e4e55a",
  null
  
)

export default component.exports